<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id='home' ref="home">
      <swiper :options="pagination">
        <swiper-slide>
          <div class="swiper-box">
            <img src="../assets/swiper-1.png" class="banner">
            <div class="swiper-text">
              <p class="text-1">用數據說話</p>
              <!-- <p class="text-2">BRAND INTELLIGENCE</p> -->
              <p class="text-3">透過深入理解您的業務方向和營運模式，利用先進的技術和數據分析，我們為您提供更全面的數據驅動的行銷策略</p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-box">
            <img src="../assets/swiper-2.png" class="banner">
            <div class="swiper-text">
              <p class="text-1">全方位，客製化</p>
              <!-- <p class="text-2">品牌出海智能分銷解決方案</p> -->
              <p class="text-3">我們是發展迅速的全方位網路行銷公司之一，針對客戶業務客製化針對性的解決方案，提供優秀的數位行銷服務組合。</p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="advantage-box">
      <div class="title">核心優勢</div>
      <div class="sbtitle">我們是一個全方位的數位行銷機構，滿足您所有的成長需求。 <br>
        需要一份涵蓋全方位的業務數位行銷計劃嗎？ 我們能為您提供全面支援！</div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/img-1.png" alt="">
          <div class="advantage-item">
            <p class="advantage-1">數位行銷廣告</p>
            <!-- <p class="advantage-2">Brand Intelligence</p> -->
            <p class="advantage-3">我們是優質海外媒體的長期合作夥伴，熟知媒體投放規則，全面覆蓋海外用戶的同時有效觸達目標族群

              我們擁有經驗豐富的數位行銷團隊，資深創意與設計團隊，幫助廣告主透過覆蓋全球的優質媒體資源進行數位行銷推廣。</p>
          </div>
        </div>

        <div class="item">
          <img src="../assets/img-2.png" alt="">
          <div class="advantage-item">
            <p class="advantage-1">社群媒體管理</p>
            <!-- <p class="advantage-2">Brand Intelligence</p> -->
            <p class="advantage-3">我們提供社群媒體管理服務，以增強在Facebook、Instagram、TikTok、Pinterest和Twitter上的銷售和收入。 我們將充分分析不同受眾群體的特點，並透過引人注目的創意和精準的受眾定位來提升廣告的效果。 透過我們的Facebook廣告漏斗策略，您是否準備好將您的Facebook廣告活動的影響規模擴展為目前的3倍、5倍或10倍？</p>
          </div>
        </div>
      </div>
      <div class="item-box advantage">
        <div class="item">
          <img src="../assets/img-3.png" alt="">
          <div class="advantage-item">
            <p class="advantage-1">SEO服務</p>
            <!-- <p class="advantage-2">Brand Intelligence</p> -->
            <p class="advantage-3">我們為希望從 Google 獲得數千或數十萬免費流量的品牌和商店提供 SEO 服務。 我們將給予客戶在其網站中可實施的所有 Google SEO優化建議，例如架構、標籤、描述、內部連結等。 您有興趣了解您目前的 SEO 狀態嗎？</p>
          </div>
        </div>

        <div class="item">
          <img src="../assets/img-4.png" alt="">
          <div class="advantage-item">
            <p class="advantage-1">品牌行銷全鏈路智慧化方案</p>
            <!-- <p class="advantage-2">Brand Intelligence</p> -->
            <p class="advantage-3">利用先進的技術和數據分析來實現全方位的品牌推廣和管理。 涵蓋了從品牌建立到市場推廣的整個過程，我們將透過深入了解目標受眾的行為和喜好，精準定位品牌傳播的管道和內容。</p>
          </div>
        </div>
      </div>
    </div>

    <div class="business-box">
      <div class="title">業務範圍</div>
      <div class="sbtitle">我們將透過獲利的數位行銷活動幫助您擴大業</div>
      <div class="business-list">
        <div class="business-item">
          <img src="../assets/list-1.png" alt="">
          <div>Google廣告</div>
          <p>如果不了解廣告評級、Auction Insights、 Impression Share，以及製定轉換效率最高的投放策略，請不要浪費金錢盲目去投放 Google Ads 廣告。 我們有數百個投資回報率不佳的 Google Ads 帳戶改進經驗。 請與我們聯繫，我們將為您提供更專業的投放策略。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-2.png" alt="">
          <div>Facebook廣告</div>
          <p>想製作出打動人心，並產生實際轉換的Facebook廣告，需要具備專業的心理學以及深刻社會洞察。 我們與各行業數百個 Facebook 廣告帳號合作打造了打動潛在客戶並取得實體產品銷售額、品牌影響力的提升的廣告。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-3.png" alt="">
          <div>素材製作</div>
          <p>內容是行銷活動的核心。 我們將針對您的受眾精心製作和提供獨特、資訊豐富且有說服力的內容。 我們專注整合全球創意資源，高品質輸出符合目標市場特性的本土化創意內容。 我們提供多種形式影片廣告，包括真人短片、UE4動畫、互動式，品牌TVC等，優化廣告體驗。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-4.png" alt="">
          <div>轉換率優化</div>
          <p>我們幫助您改善主頁的使用者體驗，進而提高轉換率。 我們將針對您的網站主頁進行使用者研究和問卷調查、定性和定量研究和 A/B 測試，用於提升使用者體驗，並提高轉換率。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-5.png" alt="">
          <div>本地SEO優化</div>
          <p>本地搜尋引擎優化是發展本地業務的重要工具。 它是一種針對本地業務的行銷策略，旨在提高您的企業在當地搜尋結果中的可見性和排名，有助於您在您的地理位置附近吸引更多的潛在客戶，並增加線下到 店或線上轉化。 我們能夠提升您在本地區域的影響力和知名度。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-6.png" alt="">
          <div>網站分析</div>
          <p>我們提供網頁端及App端的資料追蹤與分析服務。 如果您無法追蹤用戶在網站上的行為，並進行分析，那麼行銷活動就很難取得成功。 我們發揮我們的優勢，透過事件和目標追蹤每一次宏觀和微觀轉換並進行深入分析，為您下次更好的行銷活動提供數據支撐。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-7.png" alt="">
          <div>行銷自動化</div>
          <p>行銷自動化，是每個團隊和企業的理想中的行銷手段。 依賴強大的數據基礎能力，對目標用戶進行更豐富、更細緻的分析。 透過行為追蹤方式，利用接觸點對潛在用戶進行自動評分、優先排定等，了解潛在用戶的興趣及其所處生命週期階段，從而製定針對性的行銷策略。 我們將可大幅提升行銷環節效率，深入了解各專案的營運狀況，提升行銷 ROI。</p>
        </div>
        <div class="business-item">
          <img src="../assets/list-8.png" alt="">
          <div>分析和報告</div>
          <p>我們的專家團隊確保您將收到所有帳戶和廣告資料定期分析報告。 我們的專家將以報告形式分析廣告轉換的每一個微小的變化，並在會議中與您詳盡討論其緣由以及優缺點。</p>
        </div>
      </div>

    </div>

    <div class="cooperative-brands">
      <div class="title">合作品牌</div>
      <div class="brands-box">
        <img src="../assets/icon-18.png" alt="">
        <img src="../assets/icon-19.png" alt="">
        <img src="../assets/icon-20.png" alt="">
        <img src="../assets/icon-21.png" alt="">
        <img src="../assets/icon-22.png" alt="">
        <img src="../assets/icon-23.png" alt="">

      </div>
    </div>
    <div class="message-us">
      <div class="title">MESSAGE US</div>
      <div class="input-box">
        <input type="text" name="fname" placeholder="姓" class="input-text">
        <input type="text" name="fname" placeholder="名" class="input-text">
      </div>
      <div class="input-box">
        <input type="text" name="fname" placeholder="郵箱" class="input-text">
        <input type="text" name="fname" placeholder="公司名稱" class="input-text">
      </div>
      <div class="input-box">
        <input type="text" name="fname" placeholder="主題" class="input-text input-theme">
      </div>
      <div class="input-box">
        <textarea type="text" name="fname" placeholder="留言" rows="5" class="input-text input-message"></textarea>
      </div>
      <div class="btn-box">發送</div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import "swiper/swiper.min.css";
// import 'swiper/css'
import 'swiper/css/swiper.min.css'
export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
    Swiper,
    SwiperSlide,
    directive
  },
  data() {
    return {
      pagination: {
        autoplay: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
      }
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.banner-box {
  .swiper-box {
    height: 720px;
    position: relative;

    .banner {
      height: 720px;
    }

    .swiper-text {
      position: absolute;
      left: 252px;
      top: 245px;
      width: 759px;

      .text-1 {
        font-size: 64px;
        font-weight: 500;
        color: #333333;
      }

      .text-2 {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
      }

      .text-3 {
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        margin-top: 24px;
      }
    }
  }
}

.advantage-box {
  margin-top: 80px;

  .title {
    font-size: 64px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }

  .sbtitle {
    text-align: center;
    font-size: 20px;
    margin-top: 28px;
  }

  .item-box {
    padding: 80px 252px 0px 252px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 584px;
      height: 160px;
      background: #FFFFFF;
      box-shadow: 0px 12px 14px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      border: 1px solid #EDEDED;
      padding: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 160px;
        height: 160px;
      }
    }

    .advantage-item {
      margin-left: 40px;

      .advantage-1 {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
      }

      .advantage-2 {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
      }

      .advantage-3 {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin-top: 24px;
      }
    }
  }

  .advantage {
    padding: 56px 252px 0px 252px;
  }
}

.message-us {
  margin-top: 200px;
  padding: 0px 360px 180px 360px;

  .title {
    font-size: 64px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }

  .input-box {
    margin-top: 37px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .input-text {
      width: 520px;
      height: 48px;
      background: #F5F5F5;
      border-radius: 8px;
      border: 0px;
      padding: 0px 20px;
      outline: none;
    }

    .input-theme {
      width: 1160px;
    }

    .input-message {
      width: 1160px;
      height: 160px;
      padding: 20px;
    }
  }

  .btn-box {
    width: 120px;
    height: 56px;
    background: #4CA0D7;
    border-radius: 4px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
    margin-top: 48px;
    float: right;
    cursor: pointer;
  }
}

.business-box {
  padding: 160px 240px;

  .title {
    font-size: 64px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }

  .sbtitle {
    font-size: 24px;
    margin-top: 16px;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  .business-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .business-item {
      width: 244px;
      height: 496px;
      background: #FFFFFF;
      box-shadow: 0px 12px 14px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      border: 1px solid #EDEDED;
      padding: 48px;
      margin-top: 48px;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;

      img {
        width: 80px;
      }

      div {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        margin-top: 32px;
      }

      p {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        margin-top: 10px;
      }
    }
  }
}

.cooperative-brands {
  padding: 0px 240px;

  .title {
    font-size: 64px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }

  .brands-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 72px;

    img {
      width: 230px;
    }
  }
}
</style>
